var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 442,
    viewBox: "0 0 243 442",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47976 392.462C-39.3697 401.663 -94.2669 376.383 -136.079 353.333C-176.541 331.027 -179.326 289.713 -196.582 246.853C-215.248 200.492 -251.22 163.616 -222.865 122.461C-195.704 83.0396 -141.074 146.679 -94.3996 136.037C-54.115 126.853 -12.9246 54.2255 26.8151 65.5373C76.9262 79.8012 166.713 100.865 188.199 148.33C211.265 199.284 118.256 229.892 89.7209 277.996C62.4887 323.904 59.8558 382.174 7.47976 392.462Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.315201 377.234C-41.9202 385.53 -91.4104 362.74 -129.104 341.961C-165.581 321.853 -168.092 284.609 -183.648 245.972C-200.475 204.178 -232.903 170.935 -207.341 133.834C-182.855 98.2962 -133.606 155.665 -91.528 146.072C-55.211 137.792 -18.0767 72.3191 17.7489 82.5161C62.9245 95.3745 143.868 114.362 163.238 157.151C184.031 203.085 100.183 230.679 74.4574 274.045C49.9069 315.43 47.5328 367.96 0.315201 377.234Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.06388 367.026C-43.1101 374.697 -88.8619 353.633 -123.708 334.428C-157.429 315.843 -159.749 281.416 -174.128 245.703C-189.683 207.071 -219.66 176.345 -196.027 142.049C-173.388 109.198 -127.861 162.225 -88.9605 153.356C-55.3857 145.701 -21.0527 85.1789 12.0669 94.6029C53.8304 106.486 128.661 124.034 146.565 163.585C165.786 206.043 88.2687 231.553 64.484 271.64C41.7856 309.895 39.5884 358.451 -4.06388 367.026Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8.27412 352.915C-41.6501 359.475 -80.7507 341.497 -110.53 325.103C-139.349 309.238 -141.323 279.836 -153.605 249.338C-166.891 216.349 -192.507 190.114 -172.298 160.818C-152.94 132.756 -114.039 178.033 -80.7873 170.449C-52.088 163.903 -22.728 112.205 5.57827 120.246C41.2721 130.385 105.228 145.354 120.522 179.129C136.941 215.386 70.6779 237.192 50.3388 271.433C30.9286 304.111 29.039 345.581 -8.27412 352.915Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-15.8825 344.373C-46.2835 350.344 -81.9069 333.938 -109.039 318.981C-135.296 304.506 -137.103 277.696 -148.301 249.884C-160.414 219.799 -183.756 195.869 -165.356 169.163C-147.732 143.582 -112.281 184.879 -81.9939 177.973C-55.853 172.014 -29.1244 124.884 -3.3369 132.225C29.1807 141.481 87.4445 155.15 101.387 185.951C116.355 219.017 56.0008 238.878 37.4841 270.094C19.813 299.884 18.1047 337.697 -15.8825 344.373Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-21.7461 331.412C-48.2499 336.617 -79.3091 322.305 -102.965 309.258C-125.858 296.631 -127.436 273.249 -137.202 248.992C-147.765 222.753 -168.118 201.881 -152.08 178.592C-136.717 156.284 -105.806 192.303 -79.4013 186.284C-56.6115 181.089 -33.3137 139.99 -10.8307 146.394C17.5201 154.47 68.3175 166.397 80.4763 193.261C93.5288 222.1 40.9128 239.416 24.7726 266.638C9.36963 292.617 7.88427 325.594 -21.7461 331.412Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-27.1117 324.737C-51.2773 329.481 -79.598 316.427 -101.169 304.525C-122.043 293.007 -123.484 271.682 -132.39 249.558C-142.024 225.627 -160.583 206.589 -145.961 185.35C-131.956 165.006 -103.768 197.859 -79.6933 192.372C-58.9141 187.636 -37.6748 150.154 -17.1745 155.997C8.67613 163.365 54.9937 174.247 66.0822 198.748C77.9858 225.051 30.0124 240.839 15.2982 265.665C1.25605 289.357 -0.0955642 319.433 -27.1117 324.737Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-40.1202 301.799C-57.128 305.139 -77.0589 295.955 -92.2393 287.583C-106.93 279.48 -107.942 264.477 -114.209 248.911C-120.987 232.074 -134.048 218.68 -123.756 203.735C-113.897 189.42 -94.0616 212.534 -77.1174 208.671C-62.4929 205.338 -47.5423 178.964 -33.1148 183.074C-14.9219 188.256 17.6753 195.909 25.4776 213.148C33.8533 231.653 12.6223 248.483 2.26488 265.951C-7.61951 282.622 -21.1061 298.065 -40.1202 301.799Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-45.1901 291.066C-58.8616 293.756 -74.8727 286.411 -87.0665 279.712C-98.8666 273.229 -103.529 262.294 -104.693 248.734C-104.035 244.369 -104.231 243.748 -100.265 238.008C-92.3306 226.527 -88.473 219.563 -74.8522 216.454C-63.0962 213.77 -51.0602 192.621 -39.4681 195.903C-24.8507 200.043 1.34121 206.152 7.59847 219.962C14.3156 234.788 -2.76046 248.293 -11.0981 262.302C-19.0549 275.67 -29.9058 288.059 -45.1901 291.066Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-46.3284 278.572C-56.4421 280.574 -68.2636 275.224 -77.2643 270.339C-85.9743 265.612 -89.3976 257.605 -90.2288 247.666C-89.7324 244.465 -89.8763 244.01 -86.9313 239.794C-81.0402 231.359 -78.173 226.245 -68.0959 223.936C-59.3984 221.943 -50.4537 206.411 -41.8905 208.792C-31.0924 211.795 -11.7412 216.217 -7.1451 226.328C-2.21119 237.182 -14.8656 247.121 -21.0604 257.409C-26.9722 267.228 -35.0217 276.334 -46.3284 278.572Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftExperience);
export default __webpack_public_path__ + "static/media/Left-Experience.7b10cffc00f273542deca8922a3c07be.svg";
export { ForwardRef as ReactComponent };